import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { FormikInput } from '../../../components';

export default function FieldValue({ label, value }) {
  return (
    <Row>
      <Col md={6} className="">
        <strong>{label}</strong>
      </Col>
      <Col className="col-1 sample-row" />
      <Col md={4} className="disabled_input--settlement">
        <FormikInput leftAddon="$" value={value} disabled />
      </Col>
    </Row>
  );
}
